import { ClientStatus } from './client.models';

export const STATUS_LABELS: Record<ClientStatus, string> = {
  ATIVO: 'Ativo',
  INATIVO: 'Inativo',
};

export const STATUS_OPTIONS = (['ATIVO', 'INATIVO'] as ClientStatus[])
  .map((value) => ({ value, label: STATUS_LABELS[value] }));

export function statusBadge(status: ClientStatus): string {
  return status === 'ATIVO' ? 'bg-success-soft' : 'bg-secondary-soft';
}
